import { CEZ_GREEN, CEZ_GREEN_DARK, CADMIUM_GREEN, GRAPH_GREY_FONT_COLOR, OLD_LAVENDER, WHITE, YELLOW_GREEN } from '../constants/colors';

const GRAPH_BASE_FONT_SIZE = 12;
const GRAPH_BASE_FONT_COLOR = GRAPH_GREY_FONT_COLOR;
const GRAPH_BASE_FONT_FAMILY = 'RoobertCEZ, Nimbus, Arial';

export const theme = {
  primaryColor: CADMIUM_GREEN,
  secondaryColor: OLD_LAVENDER,
  title: { primaryColor: YELLOW_GREEN, secondaryColor: WHITE },
  loader: { primaryColor: CEZ_GREEN, secondaryColor: CEZ_GREEN_DARK },
  datatable: { body: { rowHeight: 32 } },
  sizes: {
    medium: '1350px',
  },
  graph: {
    baseFontSize: GRAPH_BASE_FONT_SIZE,
    baseFontColor: GRAPH_BASE_FONT_COLOR,
    baseFontFamily: GRAPH_BASE_FONT_FAMILY,
    baseFontStyle: `font-size: ${GRAPH_BASE_FONT_SIZE}px;
      color: ${GRAPH_BASE_FONT_COLOR};
      font-family: ${GRAPH_BASE_FONT_FAMILY};`,
    indexLabelSize: 9,
  },
  buttons: {
    backGroundColor: {
      primaryColor: CEZ_GREEN,
      secondaryColor: WHITE,
    },
    color: { primaryColor: WHITE, secondaryColor: CEZ_GREEN },
  },
  checkboxes: {
    color: {
      primaryColor: CEZ_GREEN,
    },
  },
};

export const CORNER_RADIUS = 4;
